import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
// import { Auth } from './auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(public router: Router, private oidcSecurityService: OidcSecurityService) {}

    canActivate(): boolean {
        if(!this.oidcSecurityService.isAuthenticated()){
            this.router.navigate(['/login']);
            return false;
        }
        // if (!this.auth.isAuthenticated()) {
            //   this.router.navigate(['/login']);
            //   return false;
        // }

        return true;
    }
}